import { jsx as _jsx } from "react/jsx-runtime";
import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from '@mui/material';
export const CloseDialogButton = (props) => {
    const { onClose } = props;
    return (_jsx(IconButton, { "aria-label": "close", onClick: onClose, sx: {
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
        }, children: _jsx(CloseIcon, {}) }));
};
